import { Box, Typography, type SxProps, type Theme } from '@mui/material';

import { heroGradient, redColors } from 'theme/colors';

interface PhoneCtaButtonProps {
  phone: string;
  label: string;
  icon?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const PhoneCtaButton: React.FC<PhoneCtaButtonProps> = ({ phone, label, icon, sx }: PhoneCtaButtonProps) => (
  <Box
    component='a'
    href={`tel:${phone}`}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 1.25,
      background: heroGradient,
      color: 'typography.light',
      borderRadius: '11px',
      px: 3,
      py: 1.6,
      textDecoration: 'none',
      width: 'fit-content',
      whiteSpace: 'nowrap',
      boxShadow: `0 0 40px -10px ${redColors.dark}`,
      ...sx,
    }}
  >
    {icon}
    <Typography variant='p3b'>{label}</Typography>
  </Box>
);

export default PhoneCtaButton;
